import { css } from '@emotion/css';
import { ClockIcon } from '../assets/icons';
import { Colors } from '../styles/colors';
import { p1Style } from '../styles/text';

export const NoActivityYet = (): JSX.Element => {
  return (
    <div className={containerStyle}>
      <div className={iconWrapStyle}>
        <ClockIcon className={imageStyle} />
      </div>
      <div className={textStyle}>No activity yet</div>
    </div>
  );
};

const textStyle = css`
  ${p1Style}
  color: ${Colors.TEXT_SECONDARY};
  padding-top: 1.5rem;
`;

const iconWrapStyle = css`
  align-self: center;
  width: 6rem;
  height: 6rem;
  border-radius: 50%;
  background: ${Colors.SURFACE};
  display: flex;
  align-items: center;
  justify-content: center;
`;

const imageStyle = css`
  width: 3rem;
  height: 3rem;
  color: ${Colors.CAPRI_BLUE};
  path {
    fill: ${Colors.CAPRI_BLUE};
  }
`;

const containerStyle = css`
  display: flex;
  flex-direction: column;
  text-align: center;

  justify-self: center;
  height: 60vh;
  justify-content: center;
`;
